var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSipWith100(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 56,
    viewBox: "0 0 97 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 97,
    height: 55.4286,
    rx: 3.46429,
    fill: "#EBE2F5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1353_32767)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3.46484,
    y: 3.46429,
    width: 90.0714,
    height: 48.5,
    rx: 3.46429,
    fill: "#C6A9EA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58.8926,
    y: 3.46429,
    width: 22.5179,
    height: 48.5,
    fill: "#B28CE2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62.3574,
    y: 6.92859,
    width: 15.5893,
    height: 3.46429,
    fill: "#EBE2F5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.125,
    y: 6.92859,
    width: 15.5893,
    height: 3.46429,
    fill: "#EBE2F5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65.8223,
    y: 12.125,
    width: 8.66071,
    height: 3.46429,
    fill: "#EBE2F5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.5898,
    y: 12.125,
    width: 8.66071,
    height: 3.46429,
    fill: "#EBE2F5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.46345,
    cy: 27.7143,
    r: 8.66071,
    fill: "#E2D4F6"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48.5006,
    cy: 27.7143,
    r: 8.66071,
    fill: "#7029CB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.0527,
    y: 45.0357,
    width: 17.3214,
    height: 3.46429,
    fill: "#EBB5AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.4162 25.4645L51.1201 26.509H45.5762L45.8722 25.4645H51.4162ZM48.7182 32.0445L45.6903 28.3697L45.6819 27.5451H47.1831C47.5581 27.5451 47.8752 27.4873 48.1346 27.3717C48.394 27.2561 48.5913 27.0883 48.7266 26.8684C48.862 26.6457 48.9296 26.3751 48.9296 26.0565C48.9296 25.5829 48.7887 25.2065 48.5067 24.9274C48.2248 24.6483 47.7836 24.5088 47.1831 24.5088H45.5762L45.8849 23.3839H47.1831C47.8823 23.3839 48.4588 23.4953 48.9127 23.718C49.3666 23.9407 49.7049 24.2494 49.9276 24.6441C50.1503 25.0388 50.2617 25.4941 50.2617 26.01C50.2617 26.4695 50.1701 26.8854 49.9868 27.2575C49.8036 27.6296 49.5118 27.9327 49.1115 28.1667C48.7111 28.4007 48.1853 28.5374 47.5341 28.5769L47.4961 28.5853L50.2617 31.9726V32.0445H48.7182ZM51.4204 23.3839L51.1201 24.4369L46.6883 24.4115L46.9886 23.3839H51.4204Z",
    fill: "#C6A9EA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1353_32767"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3.46484,
    y: 3.46429,
    width: 90.0714,
    height: 48.5,
    rx: 3.46429,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSipWith100);
export default __webpack_public_path__ + "static/media/sip-with-100.a248634f7e1aa7a8589e735335a6af07.svg";
export { ForwardRef as ReactComponent };